/* eslint new-cap: 0 */

import IntercomRestClient from './intercomRestClient';
import IntercomJsClient from './intercomJsClient';
import config from '../../appConfig';
import './intercom.scss';

const intercomRestClient = new IntercomRestClient({ appId: config.intercom, apiToken: config.intercomToken, apiUrl: config.apiUrl + 'intercom/'});
let intercomClient = new IntercomJsClient(intercomRestClient, { appId: config.intercom });

// Expose the intercomClient so it can be used by GTM
window.intercomClient = intercomClient;

function switchToRestClient() {
  window.intercomClient = intercomClient = intercomRestClient;
  intercomClient.processQueue(window.Intercom.q);
}

window.addEventListener('load', () => {
  const scripts = document.getElementsByTagName('script');
  const intercomScript = Array.prototype.filter.call(scripts, script => script.src.indexOf('widget.intercom.io') >= 0)[0];
  if (intercomScript) {
    intercomScript.addEventListener('error', () => switchToRestClient());
  } else {
    setTimeout(() => {
      if (!window.Intercom.booted) {
        switchToRestClient();
      }
    }, 5000);
  }
  intercomClient.boot({});
});

export function intercomHide () {
  intercomClient.hide();
  document.body.classList.add('hide-intercom');
}

export function intercomShow () {
  // intercomClient.show();
  document.body.classList.remove('hide-intercom');
}

export function intercomShowNewMessage (message) {
  return intercomClient.showNewMessage(message);
}

export function intercomCreateLead(data) {
  return intercomRestClient.createLead(data);
}



// WEBPACK FOOTER //
// ./src/services/intercom.js